<template>
  <div id="app">

    <div class="operation-tool">
      <div @click="addCard()" class="tool-item"> <img src="../../../static/img/btn/add.png" />添加参考价</div>
    </div>

    <div class="l-panel">
      <div class="panel-body">
      <el-table class="l-table" stripe="" :data="tableData" style="width: 100%" >
        <el-table-column prop="distance" label="公里数" align="left" width="300"></el-table-column>
        <el-table-column prop="money" label="单价" align="right" width="300"></el-table-column>
        <el-table-column prop="addtime" label="添加时间" align="center"></el-table-column>
        <el-table-column prop="amount" label="操作" align="center">
          <template slot-scope='{row}'>
              <el-button type="danger" size="mini" @click='deleteCar(row)'>删除</el-button>
              <el-button type="primary" size="mini" @click='edit(row)'>编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="c-table-pager">
        <el-pagination  :total="total" @current-change='paginationChange'> </el-pagination>
      </div>
    </div>
    </div>


    <el-dialog :title="basic.id ?'编辑车费参考价' : '添加车费参考价'" :visible.sync="dialogVisible" width="500px">
      <div class="dialogContent">
        <el-form :model="basic" ref="basic" label-width="100px" class="demo-ruleForm" :rules="rules">
          <el-form-item label="公里数" prop="distance">
              <el-input v-model="basic.distance" placeholder="请输入公里数"></el-input>
          </el-form-item>
          <el-form-item label="单价"  prop="money">
              <el-input v-model="basic.money" placeholder="请输入单价"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('basic')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          key:'',
          begintimes:[],
          begintime:'',
          endtime:'',
          key_type:''

        },
        total: 1,
        tableData:[],
        dialogVisible:false,
        basic:{
            distance:'',
            money:'',
        },
        rules:{
           distance: [ { required: true, message: '请输入公里数', trigger: 'blur' },],
           money: [ { required: true, message: '请输入单价', trigger: 'blur' },],
        }

      }
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    mounted() {
      this.queryInfo()
    },
    methods: {

      deleteCar(row){
        this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                 this.gets('setting/sendFeeDelete',{id:row.id}).then((res)=>{
                   this.queryInfo()
                   res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                 })
                }).catch(() => {});

      },

      edit(row){
        this.basic = row;
        this.dialogVisible = true
      },

        submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                if (valid) {
                  let url = this.basic.id ? 'setting/sendFeeEdit' : 'setting/sendFeeAdd'
                    this.post(url,this.basic).then(res=>{
                      Message[res.data.code == 1?'success':'warning'](res.data.msg)
                      this.dialogVisible = res.data.code == 1? false :true;
                      this.queryInfo()
                    })
                } else {
                 return console.log('error submit!!');
                }
              });
            },

      addCard(){
        this.basic.distance = ''
        this.basic.money = ''
        this.basic.id = ''
        this.dialogVisible = true
      },

      paginationChange(val) {
        this.info.page = val
        this.queryInfo()
      },

      interviewTimeChange(val) {
        this.info.begintime = val[0]
        this.info.endtime = val[1]
        this.info.page = 1
        this.queryInfo()
      },

      searchResume() {
        this.info.page = 1
        this.queryInfo()
      },

      queryInfo() {
        this.gets('setting/sendFeeList', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      }
    }
  }
</script>

<style scoped>
  .table {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pagination >>> .button{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/system/SendFeeList.vue